<template>
  <div class="container">
    <div class="ui left aligned grid">
      <h1>Error Details</h1>
    </div>

    <div class="ui divider"></div>
    <div class="ui form grid segment">
      <div class="ui grid stackable">
        <div class="ui grid row stackable">
          <div class="eight wide column ">
            <label>ID</label>
            <input type="text" name="id" placeholder="" v-model="id" readonly />
          </div>
          <div class="eight wide column ">
            <label>Date</label>
            <input
              type="text"
              name="Date"
              placeholder=""
              v-model="date"
              readonly
            />
          </div>
        </div>

        <div class="ui grid row stackable">
          <div class="eight wide column ">
            <label>Level</label>
            <input
              type="text"
              name="level"
              placeholder=""
              v-model="level"
              readonly
            />
          </div>
          <div class="eight wide column ">
            <label>Exception</label>
            <input
              type="text"
              name="exception"
              placeholder=""
              v-model="exception"
              readonly
            />
          </div>
        </div>
        <div class="ui grid row stackable">
          <div class="sixteen wide column">
            <label>Message</label>
            <textarea v-model="message" readonly rows="20"></textarea>
          </div>
          <div class="sixteen wide column">
            <div class="ui buttons">
              <div class="ui light button" @click="$router.go(-1)">Cancel</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import { config } from "@/assets/js/variables.js";

export default {
  name: "EditPage",
  computed: {
    disabled() {
      if (this.$route.params.id == undefined) {
        return false;
      } else {
        return true;
      }
    },
  },
  components: {},
  data() {
    return {
      showModal: false,
      id: "",
      date: "",
      level: "",
      message: "",
      exception: "",
      error: "",
      config: config,
    };
  },
  mounted() {
    this.errorDetails();
  },
  methods: {
    errorDetails() {
      apiService
        .getErrorDetails({ id: this.$route.params.id })
        .then((request) => {
          this.errorSuccessful(request);
        })
        .catch((err) => this.errorFailed(err));
    },
    errorSuccessful(request) {
      (this.id = request.id),
        (this.date = request.date),
        (this.level = request.level),
        (this.message = request.message),
        (this.exception = request.exception);
    },
    errorFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
  },
};
</script>
